import { createContext } from 'react';
import initialCatalogCorrelationsState from './initialCatalogCorrelationsState';

const CatalogCorrelationsContext = createContext(initialCatalogCorrelationsState);

export default CatalogCorrelationsContext;
